module.exports = __webpack_public_path__ + "img/2.aa3df836.jpg";